export const NOTIFICATIONS_REQUEST = 'NOTIFICATIONS_REQUEST'
export const NOTIFICATIONS_SUCCESS = 'NOTIFICATIONS_SUCCESS'
export const NOTIFICATIONS_ERROR = 'NOTIFICATIONS_ERROR'
export const NOTIFICATIONS_PING = 'NOTIFICATIONS_PING'
export const NOTIFICATIONS_INTERVAL = 'NOTIFICATIONS_INTERVAL'
export const NOTIFICATIONS_SEND_READ = 'NOTIFICATIONS_SEND_READ'
export const NOTIFICATIONS_INTERVAL_CLEAR = 'NOTIFICATIONS_INTERVAL_CLEAR'